import * as Business    from '../business';
import * as Forms       from '../components/forms';
import * as User        from '../user';
import { compose }      from 'redux';
import { connect }      from 'react-redux';
import CalendarTime     from '../components/calendar_time';
import ConfirmButton    from '../components/confirm_button';
import FetchFromServer  from '../components/fetch_from_server';
import React            from 'react';
import RolesInfo        from './roles_info';
import StandaloneButton from '../components/standalone_button';


export function UserPage({ team, userID, isCurrentUser, availableRoles, navigateBackTo, statuses, load, save, remove, resendInvite }) {
  const user = team?.users.find(item => item.id === userID);

  async function onRemove() {
    await remove(user);
    navigateBackTo('../../team');
  }

  function onResend() {
    resendInvite(user);
  }

  const title = user?.name;

  return (
    <Forms.EditPage
      record={user}
      title={title}
      save={save}
      validate={validate}
    >
      {editPage => (
        <FetchFromServer statuses={statuses} load={load}>
          {editPage.record && (
            <EditUserForm
              user={user}
              isCurrentUser={isCurrentUser}
              availableRoles={availableRoles}
              onResend={onResend}
              onRemove={onRemove}
              {...editPage}
            />
          )}
        </FetchFromServer>
      )}
    </Forms.EditPage>
  );
}


export function EditUserForm({ isCurrentUser, availableRoles, onResend, onRemove, ...editPage }) {
  const user          = editPage.record;
  const canRemove     = !isCurrentUser;
  const { isEditing } = editPage;
  const isViewing     = !isEditing;

  return (
    <div>
      <Forms.Form {...editPage}>
        <UserForm isEditing={isEditing} availableRoles={availableRoles}/>
      </Forms.Form>
      {isViewing && (
        <LastActive lastActiveAt={user.lastActiveAt} onResend={onResend}/>
      )}
      {isEditing && canRemove && (
        <ConfirmButton
          label="Remove from team"
          className="remove-from-team-button"
          confirmTitle="Remove Team Member"
          confirmSubtitle={`Remove ${user.name}?`}
          confirmButtonText="Remove"
          danger={true}
          onConfirm={onRemove}/>
      )}
    </div>
  );
}


function LastActive({ lastActiveAt, onResend }) {
  if (lastActiveAt) {
    return (
      <div className="block settings-user__last-active-at">
        Last active <CalendarTime time={lastActiveAt} long={true}/>
      </div>
    );
  } else
    return <StandaloneButton label="Re-send Invitation" onClick={onResend}/>;
}


function UserForm({ availableRoles, isEditing, ...form }) {
  return (
    <div className="list block">
      <ul>
        <Forms.Error {...form}/>
        <Forms.Input  {...form} label="Name" name="name" type="text" required={true}/>
        <Forms.Input  {...form} label="Phone number" name="phone" type="tel"/>
        <Forms.Input  {...form} label="Email" name="email" type="email"/>
        <Forms.Input  {...form} label="Job title" name="title" type="text" readOnly={true}/>
        <Forms.Select {...form} label="App Role" name="role" options={availableRoles}/>
        {isEditing && (<RolesInfo roles={availableRoles}/>)}
      </ul>
    </div>
  );
}


function validate({ phone, email }) {
  if (!phone && !email)
    throw new Error('All user accounts must have an email address or phone number');
}


export default connect(
  (state, { businessID, userID, navigateBackTo }) => ({
    userID,
    availableRoles: User.getAvailableRoles(state),
    isCurrentUser:  (User.getUserID(state) === userID),
    statuses:       Business.getTeamStatuses(state, businessID),
    team:           Business.getTeam(state, businessID),
    navigateBackTo
  }),
  (dispatch, { businessID }) => ({
    load:         compose(dispatch, Business.readTeam, () => businessID),
    save:         compose(dispatch, Business.updateUser, user => ({ businessID, user })),
    remove:       compose(dispatch, Business.removeUser, user => ({ businessID, user })),
    resendInvite: compose(dispatch, Business.resendInvite, user => ({ businessID, user }))
  })
)(UserPage);
